import { Order, Worker } from '../../apiTypes';
import { createBatch } from '../../utils/api';

type Props = {
  cafeSlug: string;
  order: DbDocument<Order>;
  worker: DbDocument<Worker>;
  comment: string;
};

export const changeComment = async ({ order, worker, cafeSlug, comment }: Props) => {
  const canEdit =
    (worker?.credentials.create_and_edit_own_orders && order.workerId === worker.id) ||
    worker?.credentials.edit_orders_of_other_employees;

  if (!canEdit) {
    return;
  }

  if (worker) {
    const batch = createBatch();

    batch.update<Order>(`cafes/${cafeSlug}/orders/${order.id}`, {
      comment: comment || '',
    });

    await batch.commit();
  }
};
